import { render } from "./VerifyErrorAnimation.vue?vue&type=template&id=5ce0a8d2&scoped=true&ts=true"
import script from "./VerifyErrorAnimation.vue?vue&type=script&lang=ts"
export * from "./VerifyErrorAnimation.vue?vue&type=script&lang=ts"

import "./VerifyErrorAnimation.vue?vue&type=style&index=0&id=5ce0a8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce0a8d2"]])

export default __exports__